













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import RestClient, { RestError, ValidationError } from "../RestClient";
import DemoServer from "../shared/DemoServer";
import Utils from "../shared/Utils";
import DateFormatter from "../shared/DateFormatter";

import { BirthdayBookingForm } from "../shared/DemoData";

import Loading from "../components/general/Loading.vue";
import TextView from "../components/controls/TextView.vue";
import ApprovalList from "../components/controls/ApprovalList.vue";

import BirthdayBookingJson, { getBirthdayBookingRequestMinDate } from "../shared/BirthdayBookingJson";
import BirthdayBookingInfoJson from "../shared/BirthdayBookingInfoJson";
import BirthdayTimeSlotJson from "../shared/BirthdayTimeSlotJson";
import BirthdayCapacityJson from "../shared/BirthdayCapacityJson";
import BirthdayProgramJson, {
  BirthdayProgramDescriptionAllowedTags,
  getBirthdayProgramsGrouped,
} from "../shared/BirthdayProgramJson";
import CustomerJson, { defaultCustomerJson } from "../shared/CustomerJson";
import SepaMandateJson from "../shared/SepaMandateJson";

import { Gender } from "../shared/Gender";
import { BirthdayBookingStatus } from "../shared/BirthdayBookingStatus";
import { validateBirthdayBookingJsonBookingForm } from "../shared/BirthdayBookingJson";
import { ValidationResult, Validation } from "../shared/Validation";
import { ValidationErrorType } from "../shared/Validation";

import CustomContent from "../components/custom/BirthdaysRegistration";

export default Vue.extend({
  name: "kindergeburtstage",
  components: {
    Loading,
    TextView,
    ApprovalList,
  },
  data() {
    return {
      RestClient: RestClient,
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      Utils: Utils,
      BirthdayProgramDescriptionAllowedTags: BirthdayProgramDescriptionAllowedTags,
      FormDemoData: BirthdayBookingForm,
      Gender: Gender,
      CustomContent: CustomContent,
      getBirthdayProgramsGrouped: getBirthdayProgramsGrouped,
      genderNames: {
        male: "männlich",
        female: "weiblich",
        other: "divers",
      },
      urlParams: null as URLSearchParams | null,
      embeddedStyle: false as boolean,
      supportsDatePicker: false,
      BirthdayBookingStatus: BirthdayBookingStatus,
      birthdayInfo: null as BirthdayBookingInfoJson | null,
      selectedBirthdayProgramm: null as number | null,
      birthdayDetails: null as BirthdayBookingJson | null,
      birthdayBookingDateSlots: null as any[] | null | "loading",
      selectedBirthdayDesiredDate: "" as string,
      selectedBirthdayBookingTimeSlot: null as number | null,
      birthdayCapacity: null as BirthdayCapacityJson | null,
      validation: null as ValidationResult<BirthdayBookingJson> | null,
      toValidate: [] as string[],
      submitValidation: false,
      differentAddress: false,
      frontendValidations: {
        maximumParticipants: false,
        minimumAge: false,
        maximumAge: false,
        restrictWeekDay: false,
        restrictMonth: false,
      },
      showValidationWarning: false as boolean,
      submitLoading: false as boolean,
      submitSuccess: false as boolean,
    };
  },
  created() {
    this.getUrlParams();
    this.initBooking();
  },
  mounted() {
    this.checkDatePickerSupport();
    this.checkUseDemoData();
  },
  methods: {
    getUrlParams() {
      this.urlParams = new URL(location.href).searchParams;
    },

    async initBooking() {
      if (this.birthdayDetails == null) {
        let newCustomer = defaultCustomerJson();
        let newSepa = {
          ID: null,
          dateTime: "",
          lastUseDateTime: "",
          accountHolderFirstName: "",
          accountHolderLastName: "",
          addressStreet: "",
          addressZip: "",
          addressCity: "",
          addressCountry: "Deutschland",
          IBAN: "",
          BIC: "",
        };
        this.birthdayDetails = {
          ID: null,
          beginDateTime: "",
          endDateTime: "",
          remarks: "",
          customer: newCustomer,
          state: BirthdayBookingStatus.requestedStaffRequired,
          isStaffRequired: true,
          staffId: null,
          restrictStaffAssignmentIds: [],
          programCategory: "Tiergeburtstage",
          programTitle: "",
          programRemarks: "",
          location: "",
          estimatedChildrenCount: 1,
          price: null,
          cancellationFee: 0,
          cancellationRemarks: "",
          sepaMandate: newSepa,
          invoiceInfos: null,
        };
      }

      await this.loadBirthdayInfo();

      if (this.urlParams != null) {
        this.embeddedStyle = Utils.getUrlParamBool(this.urlParams.get("embedded"));

        let birthdayProgramId = Utils.getUrlParamNum(this.urlParams.get("birthdayProgramId"));
        if (birthdayProgramId) {
          let birthdayInfo = this.birthdayInfo?.availablePrograms.find(
            (i: BirthdayProgramJson) => i.ID == birthdayProgramId
          );
          this.birthdayDetails.programCategory = birthdayInfo ? birthdayInfo.category : "Tiergeburtstage";
          this.selectedBirthdayProgramm = birthdayProgramId;
        }
      }
    },

    checkDatePickerSupport() {
      let testvalue = "a";

      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    checkUseDemoData() {
      if (process.env.NODE_ENV == "development") {
        const vue = this;

        window.addEventListener("keypress", function (e) {
          if (e.altKey && e.key == "¡") {
            vue.birthdayDetails = JSON.parse(JSON.stringify(vue.FormDemoData));
          }
        });
      }
    },

    async loadBirthdayInfo() {
      try {
        this.birthdayInfo = await this.RestClient.getBirthdayBookingInfo();
      } catch (e) {
        alert(e.message);
      }
    },

    async getBirthdayCapacity() {
      if (this.birthdayDetails != null && this.birthdayDetails.endDateTime != "") {
        try {
          this.birthdayCapacity = await this.RestClient.getBirthdayCapacity(
            new Date(this.birthdayDetails.beginDateTime),
            new Date(this.birthdayDetails.endDateTime),
            this.birthdayDetails.programCategory,
            this.birthdayDetails.programTitle
          );
        } catch (e) {
          alert(e.message);
        }
      }
    },

    inputValidation(input: string) {
      if (this.toValidate.indexOf(input) < 0) {
        this.toValidate.push(input);
      }

      if (this.birthdayDetails != null) {
        this.validation = validateBirthdayBookingJsonBookingForm(
          this.birthdayDetails,
          this.birthdayInfo?.birthdaysCanRequestUntilDaysAhead || 0
        );
      }
    },

    removeValidationHint(input: string) {
      let index = this.toValidate.indexOf(input);

      if (index >= 0) {
        this.toValidate.splice(index, 1);
      }
    },

    /* START frontend validation */

    frontendValidation() {
      this.validateAge();
      this.validateDate();
      this.validateParticipants();
    },

    validateAge() {
      if (this.birthdayDetails != null) {
        let beginDateTime = this.birthdayDetails.beginDateTime;
        let childBirthDate = this.birthdayDetails.customer?.childBirthDate;
        let programInfo = this.getSelectedProgramInfo();

        if (beginDateTime != null && childBirthDate != null && programInfo != null) {
          let testDate = new Date(beginDateTime);
          let birthDate = new Date(childBirthDate);

          let age = testDate.getFullYear() - birthDate.getFullYear();
          let month = testDate.getMonth() - birthDate.getMonth();
          if (month < 0 || (month === 0 && testDate.getDate() < birthDate.getDate())) {
            age--;
          }

          this.frontendValidations.minimumAge = false;
          this.frontendValidations.maximumAge = false;

          if (programInfo.restrictMinimumAge != null && age < programInfo.restrictMinimumAge) {
            this.frontendValidations.minimumAge = true;
          }

          if (programInfo.restrictMaximumAge != null && age > programInfo.restrictMaximumAge) {
            this.frontendValidations.maximumAge = true;
          }
        }
      }
    },

    validateDate() {
      if (this.birthdayDetails != null) {
        var beginDateTime: Date | null = null;
        let programInfo = this.getSelectedProgramInfo();

        if (this.birthdayDetails.beginDateTime != "") {
          beginDateTime = new Date(this.birthdayDetails.beginDateTime);
        }

        if (programInfo != null) {
          this.frontendValidations.restrictWeekDay = false;
          this.frontendValidations.restrictMonth = false;

          if (beginDateTime != null) {
            if (
              programInfo.restrictWeekDays != null &&
              !programInfo.restrictWeekDays.includes(beginDateTime.getDay())
            ) {
              this.frontendValidations.restrictWeekDay = true;
            }

            if (programInfo.restrictMonths != null && !programInfo.restrictMonths.includes(beginDateTime.getMonth())) {
              this.frontendValidations.restrictMonth = true;
            }
          }
        }
      }
    },

    validateParticipants() {
      if (this.birthdayDetails != null) {
        let childrenCount = this.birthdayDetails.estimatedChildrenCount;
        let programInfo = this.getSelectedProgramInfo();

        if (programInfo != null) {
          this.frontendValidations.maximumParticipants = false;

          if (
            programInfo.restrictMaximumParticipants != null &&
            childrenCount > programInfo.restrictMaximumParticipants
          ) {
            this.frontendValidations.maximumParticipants = true;
          }
        }
      }
    },

    checkFrontendValidations() {
      let check = true;

      let k = this.frontendValidations;
      let i: keyof typeof k;
      for (i in this.frontendValidations) {
        if (this.frontendValidations[i] == true) {
          check = false;
        }
      }

      return check;
    },

    /* END frontend validation */

    checkCapacity() {
      let check = true;

      if (this.birthdayCapacity != null) {
        let k = this.birthdayCapacity;
        let i: keyof typeof k;
        for (i in this.birthdayCapacity) {
          if (this.birthdayCapacity[i] == true) {
            check = false;
          }
        }
      } else {
        check = false;
      }

      return check;
    },

    async submitForm() {
      if (this.birthdayDetails != null) {
        this.submitLoading = true;
        //this.setBirthdayProgramm()

        if (!this.differentAddress) {
          this.setDifferentAddress();
        }
        if (this.birthdayDetails.sepaMandate != null) {
          let now = new Date().toISOString();
          this.birthdayDetails.sepaMandate.dateTime = now;
        }

        this.setBirthdayDateTime();

        this.validation = validateBirthdayBookingJsonBookingForm(
          this.birthdayDetails,
          this.birthdayInfo?.birthdaysCanRequestUntilDaysAhead || 0
        );

        this.submitValidation = true;

        if (
          (this.$refs.approvalRequired as any).validate() &&
          this.checkFrontendValidations() &&
          this.checkCapacity() &&
          this.validation != null &&
          this.validation.isValid == true
        ) {
          try {
            await this.RestClient.requestBirthday(this.birthdayDetails);
            this.submitSuccess = true;
            this.submitLoading = false;
          } catch (e) {
            this.submitLoading = false;
            if (e.hasOwnProperty("validationResult")) {
              this.showValidationWarning = true;
              this.validation = e.validationResult;
              if (e.validationResult.errors.programTitle == ValidationErrorType.tooManySimultanous) {
                alert(
                  "Leider ist das Programm zu der ausgewählten Uhrzeit und/oder dem ausgewählten Tag bereits ausgebucht."
                );
              }
              if (e.validationResult.errors.beginDateTime == ValidationErrorType.tooManySimultanous) {
                alert("Leider ist die ausgewählte Uhrzeit und/oder der ausgewählte Tag bereits ausgebucht.");
              }
              if (
                e.validationResult.errors.customer != null &&
                e.validationResult.errors.customer.email == ValidationErrorType.domainLookupFailed
              ) {
                alert("Die eingegebene E-Mail Adresse ist nicht gültig. Bitte prüfen Sie auf Tippfehler.");
              }
            } else {
              alert(e.message);
            }
          }
        } else {
          this.showValidationWarning = true;
          this.submitLoading = false;
        }
      }
    },

    setDifferentAddress() {
      if (this.birthdayDetails != null) {
        if (this.birthdayDetails.customer != null && this.birthdayDetails.sepaMandate != null) {
          this.birthdayDetails.sepaMandate.accountHolderFirstName = this.birthdayDetails.customer.guardianFirstName;
          this.birthdayDetails.sepaMandate.accountHolderLastName = this.birthdayDetails.customer.guardianLastName;

          this.birthdayDetails.sepaMandate.addressStreet = this.birthdayDetails.customer.addressStreet;
          this.birthdayDetails.sepaMandate.addressZip = this.birthdayDetails.customer.addressZip;
          this.birthdayDetails.sepaMandate.addressCity = this.birthdayDetails.customer.addressCity;
          this.birthdayDetails.sepaMandate.addressCountry = this.birthdayDetails.customer.addressCountry;
        }
      }
    },

    setBirthdayDateTime() {
      if (this.birthdayDetails != null) {
        if (this.selectedBirthdayBookingTimeSlot != null) {
          if (this.birthdayInfo != null && this.timeSlots !== undefined) {
            let timeSlot = this.timeSlots[this.selectedBirthdayBookingTimeSlot];

            let date = DateFormatter.formatUSDate(new Date(this.birthdayDetails.beginDateTime));

            this.birthdayDetails.beginDateTime = DateFormatter.formatISODateTime(
              new Date(date + " " + timeSlot.beginTime)
            );
            this.birthdayDetails.endDateTime = DateFormatter.formatISODateTime(new Date(date + " " + timeSlot.endTime));

            this.inputValidation("beginDateTime");
            this.inputValidation("endDateTime");
          }
        }
      }
    },

    setBirthdayProgramm() {
      if (this.birthdayDetails != null && this.birthdayInfo != null) {
        if (
          this.birthdayInfo.availablePrograms != null &&
          this.birthdayDetails.programCategory != null &&
          this.selectedBirthdayProgramm != null
        ) {
          let programm = this.birthdayInfo.availablePrograms.find(
            (i: BirthdayProgramJson) => i.ID == this.selectedBirthdayProgramm
          );
          if (programm != undefined) {
            this.birthdayDetails.programTitle = programm.title;
            this.birthdayDetails.programRemarks = programm.remarks;
            this.birthdayDetails.price = null;
            this.birthdayDetails.cancellationFee = programm.cancellationFee;
            this.birthdayDetails.cancellationRemarks = programm.cancellationRemarks;
            this.birthdayDetails.restrictStaffAssignmentIds = programm.restrictStaffAssignmentIds;
            this.birthdayDetails.isStaffRequired = programm.isStaffRequired;
          }
        }
      }
    },

    getSelectedProgramInfo() {
      if (this.birthdayInfo != null && this.birthdayDetails != null) {
        return this.birthdayInfo.availablePrograms.find(
          (i: BirthdayProgramJson) => i.ID == this.selectedBirthdayProgramm
        );
      }
    },
  },

  watch: {
    selectedBirthdayBookingTimeSlot: {
      handler(val, oldVal) {
        if (val === null) {
          if (this.birthdayDetails != null) {
            this.birthdayDetails.endDateTime = "";
          }
        }

        this.setBirthdayDateTime();

        this.getBirthdayCapacity();
      },
      deep: true,
    },

    selectedBirthdayProgramm: {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.inputValidation("programTitle");
          if (this.validation != null) {
            this.validation.errors.programTitle = null;
            this.setBirthdayProgramm();

            this.getBirthdayCapacity();
          }
        }
      },
      deep: true,
    },
  },

  computed: {
    bookingMinDateISO(): string {
      return DateFormatter.formatISODate(
        getBirthdayBookingRequestMinDate(this.birthdayInfo?.birthdaysCanRequestUntilDaysAhead ?? 1)
      );
    },

    parseEstimatedChildrenCount: {
      get(): number | undefined {
        if (this.birthdayDetails != null) {
          return this.birthdayDetails.estimatedChildrenCount;
        }
      },
      set(value: string) {
        if (this.birthdayDetails != null) {
          this.birthdayDetails.estimatedChildrenCount = parseInt(value);
        }
      },
    },

    formatBirthDate: {
      get(): string | undefined {
        if (this.birthdayDetails != null) {
          if (this.supportsDatePicker) {
            return this.birthdayDetails.customer.childBirthDate!;
          } else {
            if (this.birthdayDetails.customer.childBirthDate != "") {
              let d = new Date(this.birthdayDetails.customer.childBirthDate!);
              let date = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
              let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
              return date + "." + month + "." + d.getFullYear();
            }
          }
        }
      },
      set(value: string) {
        if (this.birthdayDetails != null) {
          if (this.supportsDatePicker) {
            this.birthdayDetails.customer.childBirthDate = value;
          } else {
            if (value.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(value);
              if (d != null) {
                this.birthdayDetails.customer.childBirthDate = DateFormatter.formatISODateTime(d);
              }
            } else {
              if (value == "") {
                this.birthdayDetails.customer.childBirthDate = "";
              }
            }
          }
        }
      },
    },

    birthdayProgrammsToBook(): object | undefined {
      if (this.birthdayInfo != null && this.birthdayInfo.availablePrograms != null) {
        let birthdayProgrammsToBook = JSON.parse(JSON.stringify(this.birthdayInfo.availablePrograms));

        return birthdayProgrammsToBook;
      }
    },

    /* customTimeSlotsToday(): BirthdayTimeSlotJson[] | undefined {
         if (this.birthdayInfo != null && this.birthdayDetails != null) {
            var customTimeSlotsToday

            if (this.birthdayDetails.beginDateTime != "") {
               var selectedDay = new Date(this.birthdayDetails.beginDateTime).getDay()

               if (selectedDay > 0 && selectedDay < 6) {
                  customTimeSlotsToday = this.birthdayInfo.customTimeSlots.filter((item) => item.isWeekendOnly == false)
               } else {
                  customTimeSlotsToday = this.birthdayInfo.customTimeSlots
               }
            } else {
               customTimeSlotsToday = undefined
            }

            return customTimeSlotsToday
         }
      }, */

    timeSlots(): BirthdayTimeSlotJson[] | undefined {
      if (this.birthdayInfo != null && this.birthdayDetails != null) {
        if (this.birthdayDetails.beginDateTime != "") {
          var selectedProgramInfo = this.getSelectedProgramInfo();

          if (selectedProgramInfo !== undefined) {
            var timeSlots;

            var selectedDay = new Date(this.birthdayDetails.beginDateTime).getDay();

            if (selectedProgramInfo.alternateTimeSlots != null) {
              timeSlots = selectedProgramInfo.alternateTimeSlots;
            } else {
              timeSlots = this.birthdayInfo.customTimeSlots;
            }

            if (selectedDay > 0 && selectedDay < 6) {
              timeSlots = timeSlots.filter((item) => item.isWeekendOnly == false);
            }

            return timeSlots;
          }
        }

        return undefined;
      }
    },

    formatDateTime: {
      get(): string | undefined {
        if (this.birthdayDetails != null) {
          if (this.supportsDatePicker) {
            let d = new Date(this.birthdayDetails.beginDateTime);
            return DateFormatter.formatISODate(d);
          } else {
            if (this.birthdayDetails.beginDateTime != "") {
              let d = new Date(this.birthdayDetails.beginDateTime);
              let date = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
              let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
              return date + "." + month + "." + d.getFullYear();
            }
          }
        }
      },
      set(value: string) {
        if (this.birthdayDetails != null) {
          if (this.supportsDatePicker) {
            if (value.match(/^\d{4}-\d{2}-\d{2}$/g)) {
              let d = new Date(value);
              let minD = new Date(this.bookingMinDateISO);

              if (d >= minD) {
                this.birthdayDetails.beginDateTime = DateFormatter.formatISODateTime(d);
              }
            } else {
              if (value == "") {
                this.birthdayDetails.beginDateTime = "";
              }
            }
          } else {
            if (value.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(value);
              if (d != null) {
                this.birthdayDetails.beginDateTime = DateFormatter.formatISODateTime(d);
              }
            } else {
              if (value == "") {
                this.birthdayDetails.beginDateTime = "";
              }
            }
          }
        }
      },
    },

    formatIBAN: {
      get(): string | undefined {
        if (this.birthdayDetails != null) {
          if (this.birthdayDetails.sepaMandate != null) {
            return this.birthdayDetails.sepaMandate.IBAN.toUpperCase()
              .replace(/[^0-9A-Z]/g, "")
              .replace(/(.{1,4})/g, "$1 ")
              .trim();
          }
        }
      },
      set(value: string) {
        if (this.birthdayDetails != null) {
          if (this.birthdayDetails.sepaMandate != null) {
            this.birthdayDetails.sepaMandate.IBAN = value;
          }
        }
      },
    },
  },
});
